import _ from 'lodash';

const initialState = {
	errorsLog: [],
	errorDetails: [],
};

export default function errors(state = initialState, action) {
  	switch (action.type) {
		case 'ADD_ERROR_LOG':
			let errorsLog = state.errorsLog;
			errorsLog.push(action.data);
			errorsLog = _.uniqBy(errorsLog, 'errorMessage');
	    	return {...state,
				errorsLog
			}
		case 'RESET_ERROR_LOG':
			return {...state,
				errorsLog: []
			}
		case 'ADD_ERROR_DETAILS':
			const errorDetails = state.errorDetails;
			errorDetails.push(action.data);
			return {...state,
				errorDetails
			}
		case 'RESET_ERROR_DETAILS':
			return {...state,
				errorDetails: []
			}
		case 'RESET_ERRORS_REDUCERS':
			return initialState;
	  	default:
	    	return state;
  	}
}



// WEBPACK FOOTER //
// ./src/App/redux/reducers/errors.js